{
  "title.notification": "Claude Code — Atenção necessária",
  "title.stop": "Claude Code — Tarefa concluída",
  "title.stopFailure": "Claude Code — Erro de API",
  "title.subagentStop": "Claude Code — Subagent finalizado",
  "title.subagentStart": "Claude Code — Subagent iniciado",
  "title.taskCreated": "Claude Code — Tarefa criada",
  "title.taskCompleted": "Claude Code — Tarefa concluída",
  "title.preCompact": "Claude Code — Compactando contexto",
  "title.postCompact": "Claude Code — Contexto compactado",
  "body.stop": "Aguardando próximo input",
  "body.notification.fallback": "Claude Code precisa da sua atenção",
  "body.stopFailure.fallback": "A sessão foi encerrada por um erro (rate limit, billing, auth, etc)",
  "body.subagentStop.fallback": "Um subagent terminou",
  "body.subagentStop.named": "O subagent '{agent}' terminou",
  "body.subagentStart.fallback": "Um subagent começou a trabalhar",
  "body.subagentStart.named": "O subagent '{agent}' começou a trabalhar",
  "body.taskCreated.fallback": "Uma nova tarefa foi criada",
  "body.taskCreated.named": "✓ Nova tarefa: {task}",
  "body.taskCompleted.fallback": "Uma tarefa foi concluída",
  "body.taskCompleted.named": "✓ {task}",
  "body.taskCompleted.named_counted": "✓ {task} ({completed}/{total})",
  "body.preCompact.fallback": "O histórico da conversa está sendo compactado",
  "body.preCompact.manual": "Compactando o histórico (solicitado por você)",
  "body.preCompact.auto": "Compactando o histórico automaticamente",
  "body.postCompact.fallback": "O histórico da conversa foi compactado",
  "body.postCompact.manual": "Histórico compactado (solicitado por você)",
  "body.postCompact.auto": "Histórico compactado automaticamente",
  "notification.type.permission_prompt": "Permissão necessária para executar uma ferramenta",
  "notification.type.idle_prompt": "Aguardando sua resposta",
  "notification.type.auth_success": "Autenticação concluída com sucesso",
  "notification.type.elicitation_dialog": "Servidor MCP solicitando informação",
  "notification.type.elicitation_complete": "Solicitação do servidor MCP concluída",
  "notification.type.elicitation_response": "Resposta enviada ao servidor MCP",
  "notification.tool_permission": "Permissão necessária para usar {tool}",
  "notification.waiting_input": "Aguardando sua resposta",
  "notification.attention": "Claude Code precisa da sua atenção",
  "notification.attention_generic": "Atenção necessária",
  "stopFailure.type.rate_limit": "Limite de uso atingido — aguarde o reset da sua cota",
  "stopFailure.type.authentication_failed": "Falha de autenticação — sua sessão expirou ou o token está inválido",
  "stopFailure.type.oauth_org_not_allowed": "Organização não autorizada a usar esta conta",
  "stopFailure.type.billing_error": "Erro de cobrança — verifique seu plano e método de pagamento",
  "stopFailure.type.invalid_request": "Requisição inválida enviada à API",
  "stopFailure.type.model_not_found": "Modelo selecionado não encontrado ou indisponível",
  "stopFailure.type.server_error": "Erro no servidor da Anthropic — tente novamente em instantes",
  "stopFailure.type.max_output_tokens": "Limite de tokens de saída atingido nesta resposta",
  "stopFailure.type.unknown": "Erro desconhecido encerrou a sessão",
  "stopFailure.fallback.rate_limit": "Limite de uso atingido",
  "stopFailure.fallback.authentication": "Falha de autenticação",
  "stopFailure.fallback.billing": "Erro de cobrança",
  "stopFailure.fallback.invalid_request": "Requisição inválida",
  "stopFailure.fallback.model": "Modelo indisponível",
  "stopFailure.fallback.server": "Erro no servidor da Anthropic",
  "stopFailure.fallback.max_tokens": "Limite de tokens de saída atingido",
  "tui.welcome.title": "Bem-vindo ao Ringly",
  "tui.welcome.tagline": "Notificações nativas cross-platform para o {target}.",
  "tui.welcome.steps_intro": "Vamos te guiar em {count} passos rápidos:",
  "tui.welcome.step1": "1 · Escolha o idioma das notificações",
  "tui.welcome.step2": "2 · Selecione quais eventos devem te notificar",
  "tui.welcome.step3": "3 · Som & preferências de debug",
  "tui.welcome.step4": "4 · Configurar a status line",
  "tui.welcome.step5": "5 · Registrar a integração com o Windows",
  "tui.language.title": "Idioma das notificações",
  "tui.language.subtitle": "Escolha o idioma usado nos títulos e corpos dos toasts.",
  "tui.language.option.auto": "Automático  —  segue o locale do sistema",
  "tui.language.option.ptbr": "Português  (pt-BR)",
  "tui.language.option.enus": "Inglês  (en-US)",
  "tui.events.title": "Escolha quais eventos devem te notificar",
  "tui.events.subtitle": "{enabled} de {total} habilitados",
  "tui.events.notification.label": "Pedidos de permissão / input",
  "tui.events.notification.desc": "Notifica quando o Claude precisa da sua atenção",
  "tui.events.stop.label": "Tarefa concluída",
  "tui.events.stop.desc": "Notifica quando o Claude termina uma resposta",
  "tui.events.stopFailure.label": "Erros de API",
  "tui.events.stopFailure.desc": "Notifica quando um erro de API encerra a sessão",
  "tui.events.subagentStop.label": "Subagent finalizado",
  "tui.events.subagentStop.desc": "Notifica quando um subagent termina (desativado por padrão)",
  "tui.events.subagentStart.label": "Subagent iniciado",
  "tui.events.subagentStart.desc": "Notifica quando um subagent começa (verboso, off por padrão)",
  "tui.events.taskCreated.label": "Tarefa criada",
  "tui.events.taskCreated.desc": "Notifica quando uma tarefa é criada (verboso, off por padrão)",
  "tui.events.taskCompleted.label": "Tarefa concluída",
  "tui.events.taskCompleted.desc": "Notifica quando uma tarefa é concluída (verboso, off por padrão)",
  "tui.events.preCompact.label": "Compactando contexto",
  "tui.events.preCompact.desc": "Notifica antes do histórico ser compactado (verboso, off por padrão)",
  "tui.events.postCompact.label": "Contexto compactado",
  "tui.events.postCompact.desc": "Notifica depois do histórico ser compactado (verboso, off por padrão)",
  "tui.sound.title": "Som e logging",
  "tui.sound.subtitle": "Habilite/desabilite som e logs detalhados.",
  "tui.sound.sound.label": "Tocar som nas notificações",
  "tui.sound.sound.desc": "Toca o som padrão do SO em cada evento",
  "tui.sound.debug.label": "Escrever logs de debug",
  "tui.sound.debug.desc": "Arquivo de log detalhado (rotacionado por tamanho)",
  "tui.statusline.title": "Status line (barra no rodapé do terminal)",
  "tui.statusline.subtitle": "{enabled} de {total} segmentos exibidos",
  "tui.statusline.explain": "Uma barra no rodapé do Claude Code que mostra modelo, tarefa atual, uso de contexto, git e limites de uso. Só pode haver uma status line ativa — ativar aqui substitui a atual (o Ringly faz backup dela e restaura se você desligar).",
  "tui.statusline.enabled.label": "Ativar a status line do Ringly",
  "tui.statusline.enabled.desc": "Interruptor mestre — instala/remove a barra",
  "tui.statusline.off_hint": "A status line está desligada — ligue acima pra usar estes segmentos.",
  "tui.statusline.position.label": "Posição do medidor de contexto",
  "tui.statusline.position.desc": "Onde a barra de contexto fica (←/→ pra alternar)",
  "tui.statusline.position.end": "fim",
  "tui.statusline.position.front": "início",
  "tui.statusline.footer.position": "posição",
  "tui.statusline.segment.model.label": "Modelo",
  "tui.statusline.segment.model.desc": "O nome do modelo atual",
  "tui.statusline.segment.task.label": "Tarefa atual",
  "tui.statusline.segment.task.desc": "A tarefa em andamento, em negrito",
  "tui.statusline.segment.dirname.label": "Pasta",
  "tui.statusline.segment.dirname.desc": "O nome da pasta de trabalho",
  "tui.statusline.segment.context.label": "Medidor de contexto",
  "tui.statusline.segment.context.desc": "Barra de uso da janela de contexto (colorida)",
  "tui.statusline.segment.lastCommand.label": "Último comando",
  "tui.statusline.segment.lastCommand.desc": "O último comando de barra que você rodou (off por padrão)",
  "tui.statusline.segment.git.label": "Status do git",
  "tui.statusline.segment.git.desc": "Branch + contagem de ahead/behind/sujos",
  "tui.statusline.segment.lines.label": "Linhas alteradas",
  "tui.statusline.segment.lines.desc": "Linhas adicionadas/removidas nesta sessão",
  "tui.statusline.segment.rateLimits.label": "Limites de uso",
  "tui.statusline.segment.rateLimits.desc": "Uso de 5h / 7d (só Pro/Max)",
  "tui.aumid.title": "Registrar integração com o Windows",
  "tui.aumid.subtitle": "Criando atalho do Menu Iniciar e AUMID para os toasts do Windows.",
  "tui.aumid.running": "Configurando integração com o Windows…",
  "tui.aumid.success": "Integração com o Windows pronta",
  "tui.aumid.already": "(já registrado, nenhuma mudança necessária)",
  "tui.aumid.notif_setting": "Status das notificações:",
  "tui.aumid.error": "Falha no registro",
  "tui.aumid.error_unknown": "erro desconhecido",
  "tui.aumid.retry_hint": "Tente {command} após corrigir o problema.",
  "tui.done.ready": "Ringly está pronto",
  "tui.done.final_step": "Passo final:",
  "tui.done.final_step_body": "registre o plugin dentro do Claude Code.",
  "tui.done.useful_commands": "Comandos úteis:",
  "tui.done.cmd_doctor": "verificar a instalação",
  "tui.done.cmd_config": "mudar configurações",
  "tui.done.cmd_test": "disparar uma notificação de teste",
  "tui.config.saved": "Configuração salva",
  "tui.config.written_to": "Gravado em",
  "tui.config.backup_created": "Um backup do arquivo anterior foi criado ao lado dele com timestamp.",
  "tui.config.reload_required": "Reload necessário",
  "tui.config.reload_body": "Rode {command} dentro do Claude Code para as novas",
  "tui.config.reload_body2": "configurações terem efeito imediato.",
  "tui.config.cli_only_title": "Configuração só pela CLI",
  "tui.config.cli_only_body": "O Ringly não usa a tela {plugin} do Claude Code. Para mudar essas configurações de novo, rode {command} ou edite ~/.claude/settings.json direto.",
  "tui.footer.continue": "continuar",
  "tui.footer.cancel": "cancelar",
  "tui.footer.move": "navegar",
  "tui.footer.select": "selecionar",
  "tui.footer.toggle": "alternar",
  "tui.footer.confirm": "confirmar",
  "tui.header.step": "Passo {step}/{total}",
  "cli.doctor.header": "Diagnóstico do Ringly",
  "cli.doctor.summary": "Resumo:",
  "cli.doctor.passed": "{count} ok",
  "cli.doctor.warning": "{count} aviso",
  "cli.doctor.warnings": "{count} avisos",
  "cli.doctor.failed": "{count} falhou",
  "cli.doctor.log_file": "Arquivo de log:",
  "cli.doctor.check.node": "Versão do Node.js",
  "cli.doctor.check.platform": "Sistema operacional",
  "cli.doctor.check.platform.scaffolded": "Suporte a {platform} está estruturado mas ainda não implementado",
  "cli.doctor.check.platform.star_hint": "Dê uma estrela no GitHub para ser avisado quando macOS / Linux chegarem.",
  "cli.doctor.check.platform.unsupported_hint": "O Ringly atualmente suporta apenas Windows.",
  "cli.doctor.check.platform.future_hint": "Toast nativo nesta plataforma chegará em uma versão futura.",
  "cli.doctor.check.node.hint": "Node 20 ou mais novo é obrigatório. Atualize em nodejs.org ou via nvm/volta.",
  "cli.doctor.check.powershell": "PowerShell",
  "cli.doctor.check.powershell.unreachable": "PowerShell inacessível",
  "cli.doctor.check.powershell.hint": "Garanta que o powershell.exe esteja no PATH.",
  "cli.doctor.check.claude": "Executável do Claude Code",
  "cli.doctor.check.claude.notfound": "não encontrado",
  "cli.doctor.check.claude.hint": "O AUMID vai usar um alvo de fallback. Rode {command} após instalar o Claude Code.",
  "cli.doctor.check.aumid": "AUMID do Windows",
  "cli.doctor.check.aumid.notreg": "não registrado",
  "cli.doctor.check.aumid.notreg_hint": "Rode {command} para registrar o atalho do Menu Iniciar e o AUMID.",
  "cli.doctor.check.aumid.mismatch_hint": "AUMID existe mas não bate com o valor esperado. Rode {command}.",
  "cli.doctor.check.aumid.missing": "propriedade ausente",
  "cli.doctor.check.aumid.repair_hint": "Rode {command} para reparar o AUMID.",
  "cli.doctor.check.plugin": "Configuração do Ringly em ~/.claude/settings.json",
  "cli.doctor.check.plugin.notfound": "{file} não encontrado",
  "cli.doctor.check.plugin.notfound_hint": "Rode {command} para configurar pela TUI (a tela do plugin manager do Claude Code não é usada pelo Ringly).",
  "cli.doctor.check.plugin.nooptions": "nenhuma opção definida (usando defaults internos)",
  "cli.doctor.check.plugin.nooptions_hint": "Rode {command} para abrir o configurador TUI do Ringly.",
  "cli.doctor.check.plugin.ok": "{count} opção(ões) definida(s) · idioma: {language}",
  "cli.doctor.check.statusline": "Status line",
  "cli.doctor.check.statusline.script_missing": "script do renderizador não encontrado",
  "cli.doctor.check.statusline.script_missing_hint": "O renderizador empacotado sumiu. Reinstale o Ringly e rode {command}.",
  "cli.doctor.check.statusline.not_wired": "ativada, mas settings.statusLine não aponta pro Ringly",
  "cli.doctor.check.statusline.not_wired_hint": "Rode {command} e desligue/ligue a status line pra reinstalá-la.",
  "cli.doctor.check.statusline.hooks_disabled": "disableAllHooks está ligado — a status line não vai rodar",
  "cli.doctor.check.statusline.hooks_disabled_hint": "Coloque disableAllHooks como false em ~/.claude/settings.json.",
  "cli.test.intro": "Disparando notificação de teste",
  "cli.test.title_label": "Título:",
  "cli.test.body_label": "Corpo: ",
  "cli.test.done": "Pronto. Veja a central de notificações se nada apareceu.",
  "cli.test.log_label": "Log:",
  "cli.test.header": "Teste do Ringly",
  "cli.uninstall.header": "Desinstalação do Ringly",
  "cli.uninstall.shortcut_removed": "Atalho do Menu Iniciar removido",
  "cli.uninstall.shortcut_failed": "Falha ao remover o atalho: {message}",
  "cli.uninstall.shortcut_absent": "Atalho não presente (pulando)",
  "cli.uninstall.config_removed": "Configurações do Ringly removidas de ~/.claude/settings.json",
  "cli.uninstall.config_absent": "Nenhuma configuração do Ringly em ~/.claude/settings.json (pulando)",
  "cli.uninstall.config_failed": "Falha ao remover a config: {message}",
  "cli.uninstall.statusline_restored": "Sua status line anterior foi restaurada",
  "cli.uninstall.statusline_absent": "Nenhuma status line do Ringly pra restaurar (pulando)",
  "cli.statusline.install_failed": "Não deu pra instalar a status line (renderizador não encontrado). Tente reinstalar o Ringly.",
  "cli.uninstall.next_steps": "Próximos passos",
  "cli.uninstall.remove_plugin": "Remova o plugin do Claude Code:",
  "cli.uninstall.remove_npm": "Remova o CLI npm:",
  "cli.init.header_noninteractive": "Ringly init  ·  não-interativo",
  "cli.init.default_saved": "Configuração padrão salva",
  "cli.init.aumid_registered": "AUMID registrado",
  "cli.init.aumid_skipped": "AUMID pulado: {reason}",
  "cli.init.next_steps_in_claude": "Próximos passos dentro do Claude Code",
  "cli.config.requires_tty": "`config` requer um terminal interativo. Configure via variáveis de ambiente ou edite",
  "cli.config.requires_tty2": "o arquivo ~/.claude/settings.json diretamente.",
  "cli.config.save_failed": "Falha ao salvar configurações: {message}",
  "cli.update.header": "Ringly update",
  "cli.update.current_version": "Versão instalada",
  "cli.update.latest_version": "Última no npm",
  "cli.update.already_latest": "Você já está na versão mais recente — {version}.",
  "cli.update.available": "Nova versão disponível: {latest} (você está na {current}).",
  "cli.update.check_failed": "Não foi possível consultar o npm (sem conexão ou registry indisponível).",
  "cli.update.confirm_prompt": "Atualizar para {latest}? [s/N]",
  "cli.update.confirm_prompt_en": "Update to {latest}? [y/N]",
  "cli.update.aborted": "Atualização cancelada.",
  "cli.update.installing": "Instalando ringly@{version}…",
  "cli.update.install_succeeded": "Atualização concluída. Rode /reload-plugins dentro do Claude Code, ou feche e reabra a sessão.",
  "cli.update.install_failed": "Falha ao rodar `npm install -g ringly@latest`. Verifique permissões e tente manualmente.",
  "cli.update.install_failed_windows_locked": "Falha — provavelmente arquivos do Claude Code estão travados. Feche o Claude Code e rode manualmente: npm install -g ringly@latest",
  "cli.update.run_manually": "Comando equivalente: {command}",
  "cli.update.toast_body": "Nova versão {latest} disponível (você está na {current}). Rode /ringly-update no Claude Code.",
  "cli.update.notes_heading": "O que mudou na versão {version}",
  "cli.update.notes_group.added": "Novidades",
  "cli.update.notes_group.changed": "Mudou",
  "cli.update.notes_group.fixed": "Correções",
  "cli.update.notes_group.breaking": "⚠ Pode quebrar coisas",
  "cli.update.notes_group.removed": "Removido",
  "cli.update.notes_group.other": "Mais detalhes",
  "cli.help.header": "Comandos do Ringly",
  "cli.help.intro": "Visão geral dos comandos disponíveis na CLI.",
  "cli.help.warning_external_terminal": "⚠ Rode estes comandos no seu terminal (PowerShell, Bash, etc.), não no chat do Claude Code.",
  "cli.help.usage_label": "Uso:",
  "cli.help.usage_value": "ringly <comando> [opções]",
  "cli.help.commands_label": "Comandos:",
  "cli.help.options_label": "Opções globais:",
  "cli.help.option.help": "Mostra esta ajuda",
  "cli.help.option.version": "Mostra a versão instalada",
  "cli.help.footer": "Para detalhes de um comando: `ringly <comando> --help`",
  "cli.help.command.test": "Dispara uma notificação de exemplo para validar o setup",
  "cli.help.command.init": "Instalador interativo (registra AUMID, escolhe opções, conecta o plugin)",
  "cli.help.command.config": "Abre a tela interativa de configuração",
  "cli.help.command.doctor": "Roda um diagnóstico do ambiente atual",
  "cli.help.command.update": "Procura uma nova versão do Ringly no npm e atualiza se quiser",
  "cli.help.command.uninstall": "Remove o atalho AUMID e a configuração local",
  "cli.help.command.help": "Mostra esta lista de comandos"
}
